import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EdMarketPlaceSurveyComponent } from './ed-market-place-survey.component';
import { EdAssistUIButtonContainerModule } from '@edassist-ui/button-container';
import { EdAssistUIModalModule } from '@edassist-ui/modal';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIParagraphModule } from '@edassist-ui/paragraph';

@NgModule({
    declarations: [ EdMarketPlaceSurveyComponent ],
    imports: [
        CommonModule,
        EdAssistUIModalModule,
        EdAssistUIParagraphModule,
        EdAssistUIButtonModule,
        EdAssistUIButtonContainerModule
    ],
    exports: [ EdMarketPlaceSurveyComponent ]    
})
export class EdMarketPlaceSurveyModule {}